<template>
    <svg width="88" height="6" viewBox="0 0 88 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="26" height="6" fill="#D4315C"/>
        <rect x="31" width="26" height="6" fill="#6FA3AF"/>
        <rect x="62" width="26" height="6" fill="#F2C152"/>
    </svg>
</template>